var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7014_7007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.571289 6.40823H5.34681M5.34681 6.40823L3.75497 4.81641M5.34681 6.40823L3.75497 8.00007",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.571289 1.71415C0.571289 1.08296 1.08296 0.571289 1.71414 0.571289H6.85701C7.4882 0.571289 7.99987 1.08296 7.99987 1.71415V11.1019C7.99987 11.7331 7.4882 12.2448 6.85701 12.2448H1.71414C1.08296 12.2448 0.571289 11.7331 0.571289 11.1019V1.71415Z",
    strokeWidth: 1.14286,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 14.2855V4.89774C15.4286 4.26656 14.9169 3.75488 14.2857 3.75488H9.14286C8.51168 3.75488 8 4.26656 8 4.89774V14.2855C8 14.9167 8.51167 15.4283 9.14286 15.4283H14.2857C14.9169 15.4283 15.4286 14.9167 15.4286 14.2855Z",
    strokeWidth: 1.14286,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4288 9.59184H10.6533M10.6533 9.59184L12.2452 8M10.6533 9.59184L12.2452 11.1837",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7014_7007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCompare);
export default __webpack_public_path__ + "static/media/outline-compare.0b00e418.svg";
export { ForwardRef as ReactComponent };